import { render, staticRenderFns } from "./BatchSiteBuild.vue?vue&type=template&id=647235f7&scoped=true"
import script from "./BatchSiteBuild.vue?vue&type=script&lang=js"
export * from "./BatchSiteBuild.vue?vue&type=script&lang=js"
import style0 from "./BatchSiteBuild.vue?vue&type=style&index=0&id=647235f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647235f7",
  null
  
)

export default component.exports